var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-bar-filters" }, [
    _c("p", { staticClass: "typographies-paragraph-small-semibold" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$l10n.__("Vous cherchez quelque chose en particulier ?")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "search-bar-filters__list" },
      _vm._l(_vm.activeFilters, function(item) {
        return _c(
          "li",
          {
            key: item.value,
            attrs: { "data-bot": "search-bar-filters__btn--" + item.dataBot }
          },
          [
            _c("CompassTagInteractive", {
              attrs: {
                modelValue: item.value,
                variant: "selectable",
                isSelected: _vm.isSelected(item),
                icon: item.icon,
                valueLabel: item.name
              },
              on: { change: _vm.handleValueChange }
            })
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }